export const CloudName = {
  Public: "Public",
  Fairfax: "Fairfax",
  USNat: "USNat",
  USSec: "USSec",
  Mooncake: "Mooncake"
};
